import { FC } from 'react';
import { BoxProps, Box, Container } from '@mui/material';


type Props = BoxProps

export const SignInBox: FC<Props> = ({ sx, children, ...props }) => {
  return (
    <Container maxWidth="xs" sx={{ padding :0 }}>
      <Box
        bgcolor="#ffffff1a"
        border={1}
        borderColor="#ffffff26"
        borderRadius="12px"
        p={4}
        sx={sx}
        {...props}
      >
        {children}
      </Box>
    </Container>
  );
};